import * as React from 'react';

export const useRefCallback = <T>(
  initialValue: T | null,
  onSetRef?: () => void
): [React.MutableRefObject<T>, (value: T) => void] => {
  const ref = React.useRef<T>(initialValue) as React.MutableRefObject<T>;
  const setRef = React.useCallback(
    (value) => {
      ref.current = value || null;
      onSetRef?.();
    },
    [onSetRef]
  );

  return [ref, setRef];
};
